export enum CustomerAccountStatusValue {
    ACTIVE = 'ACTIVE',
    BLOCKED = 'BLOCKED',
    DEACTIVATED = 'DEACTIVATED',
    GDPR_PENDING_DELETION = 'GDPR_PENDING_DELETION',
    GDPR_DELETED = 'GDPR_DELETED'
}

export enum CustomerAccountTypeValue {
    PERSONAL = 'PERSONAL',
    CORPORATE = 'CORPORATE'
}

export interface CustomerAccountStatus {
    value: string;
    translations: {
        translations: {
            [key: string]: string;
        };
    };
}

export interface CustomerAccountType {
    code: string;
    name: {
        translations: {
            [key: string]: string;
        };
    };
    description: {
        translations: {
            [key: string]: string;
        };
    };
}

export interface CustomerAccount {
    id: number | string;
    status: CustomerAccountStatus;
    type: CustomerAccountType;
    code: string;
    startDate: string;
    endDate: string | null;
    updatedAt: string | null;
    createdAt: string;
    updatedBy: number | null;
    createdBy: number;
    correlationKey: string;
    organizationPartId: number | null;
}
